// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchStatus_root__fn5sz","time":"MatchStatus_time__Xq6_W","pregame":"MatchStatus_pregame__TgeRy","live":"MatchStatus_live__dtqiS","status":"MatchStatus_status__aypBP"};